import { useRouteError } from "react-router";
import { ErrorPage } from "./ErrorPage";

/**
 * Wrapper for use as React Router errorElement: passes route error to ErrorPage.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  return <ErrorPage error={error instanceof Error ? error : undefined} />;
}
